var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"lbToggle\" ng-click=\"vm.toggle()\" ng-class=\"{ 'lbToggle-active': vm.isActive }\">\n<div class=\"lbToggle_icon\"></div>\n</div>\n";
var id1="components/lbToggle/lbToggle.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbToggle/lbToggle.html
// module id = 1760
// module chunks = 5